import { makeResetStyles, shorthands } from '@fluentui/react-components';
import {
  AIWarningIcon,
} from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

export const useBrandDetectionConfirmationStyle = makeResetStyles({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  width: '100%',
  marginTop: '32px',
  ...shorthands.padding('16px', '24px'),
  ...shorthands.gap('16px'),
  ...shorthands.borderRadius(4),
  ...shorthands.border('1px', 'solid', '#E1DFDD'),
  backgroundColor: '#FFF',

  '& .ai-warning-icon': {
    width: '128px',
    height: '128px',
    flexShrink: 0,
    backgroundImage: `url("${AIWarningIcon}")`,
    backgroundSize: '128px 128px',
    marginRight: '16px',
  },

  '& .confirmation-content': {
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    '& .confirmation-content-title': {
      color: '#000',
      fontSize: '18px',
      fontWeight: 600,
      lineHeight: '24px',
    },
    '& .confirmation-content-text': {
      color: '#605E5C',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      marginTop: '4px',
      marginBottom: '12px',
    },
    '& .confirmation-content-action': {
      display: 'flex',
      '& .confirmation-content-checkbox': {
        marginRight: '4px',
        alignItems: 'flex-start',
        '& button': {
          marginTop: '4px',
        },
      },
    },
  },
});
